import axios from "axios"
import * as actions from "../actions/lobbyist"

export function addLobbyist(lobbyist) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.REACT_APP_API_HOST}/api/lobbyist`, lobbyist)
        .then(response => {
          if (response.data.Success) {
            // update store with lobbyist view model returned from the server
            dispatch(actions.getLobbyist(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function getLobbyists() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/lobbyist`)
      .then((response) => {
        let lobbyists = response && response.data ? response.data.$values : []
        dispatch(actions.getLobbyists(lobbyists))
      })
  }
}

export function getLobbyistListItems() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/lobbyist/list`)
      .then((response) => {
        let lobbyistListItems = response && response.data ? response.data.$values : []
        dispatch(actions.getLobbyistListItems(lobbyistListItems))
      })
  }
}

export function exportLobbyistsToExcel(lobbyistIds) {
  return (dispatch) => {
    return axios.post(`${process.env.REACT_APP_API_HOST}/api/lobbyist/export`, lobbyistIds, {
      // VERY IMPORTANT - none of the files that get returned will open correctly without this
      responseType: 'blob'
    })
  }
}

export function getLobbyist(lobbyistId) {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/lobbyist/${lobbyistId}`)
      .then((response) => {
        let lobbyist = response && response.data ? response.data : {}
        dispatch(actions.getLobbyist(lobbyist))
      })
  }
}

export function updateLobbyist(lobbyist) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/lobbyist`, lobbyist)
        .then(response => {
          if (response.data.Success) {
            // update store with lobbyist view model returned from the server
            dispatch(actions.getLobbyist(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function submitLobbyist(lobbyist) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/lobbyist/${lobbyist.LobbyistId}/submit`, lobbyist)
        .then(response => {
          if (response && response.data.Success) {
            // update store with lobbyist view model returned from the server
            dispatch(actions.getLobbyist(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function approveLobbyist(lobbyistId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/lobbyist/${lobbyistId}/approve`)
        .then(response => {
          if (response.data.Success) {
            // update store with lobbyist view model returned from the server
            dispatch(actions.getLobbyist(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function getChangesRequiredLobbyist(lobbyistId) {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/lobbyist/${lobbyistId}/changes-required`)
      .then((response) => {
        let changesRequired = response && response.data ? response.data : {}
        dispatch(actions.getChangesRequired(changesRequired))
      })
  }
}

export function changesRequiredLobbyist(lobbyist) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/lobbyist/${lobbyist.LobbyistId}/changes-required`, lobbyist)
        .then(response => {
          if (response.data.Success) {
            // update store with lobbyist view model returned from the server
            dispatch(actions.getLobbyist(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function rejectLobbyist(lobbyistId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/lobbyist/${lobbyistId}/reject`)
        .then(response => {
          if (response.data.Success) {
            // update store with lobbyist view model returned from the server
            dispatch(actions.getLobbyist(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function withdrawLobbyist(lobbyistId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/lobbyist/${lobbyistId}/withdraw`)
        .then(response => {
          if (response && response.data.Success) {
            // update store with lobbyist view model returned from the server
            dispatch(actions.getLobbyist(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function addActiveLobbyistGridIndex(index) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.addActiveLobbyistGridIndex(index))
      resolve()
    })
  }
}

export function removeActiveLobbyistGridIndex(index) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.removeActiveLobbyistGridIndex(index))
      resolve()
    })
  }
}

export function reactivateLobbyist(lobbyistId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/lobbyist/${lobbyistId}/reactivate`)
        .then(response => {
          if (response.data.Success) {
            // update store with lobbyist view model returned from the server
            dispatch(actions.getLobbyist(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actionCreators/lobbyist.js